var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnergie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1341_4089)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.7536 0.202884C34.0472 0.373099 34.2744 0.637854 34.3981 0.953897C34.5218 1.26994 34.5347 1.61859 34.4346 1.94288L29.0316 19.4989H39.0006C39.2936 19.4988 39.5802 19.5844 39.825 19.7453C40.0698 19.9062 40.2622 20.1353 40.3783 20.4043C40.4944 20.6732 40.5293 20.9703 40.4785 21.2588C40.4277 21.5474 40.2936 21.8147 40.0926 22.0279L16.0926 47.5279C15.8604 47.7748 15.5514 47.9358 15.2159 47.9846C14.8805 48.0335 14.5384 47.9672 14.2454 47.7967C13.9524 47.6262 13.7258 47.3615 13.6026 47.0458C13.4793 46.73 13.4666 46.3818 13.5666 46.0579L18.9696 28.4989H9.0006C8.70763 28.499 8.42105 28.4133 8.17622 28.2524C7.93139 28.0915 7.73903 27.8625 7.62289 27.5935C7.50676 27.3245 7.47193 27.0275 7.5227 26.7389C7.57347 26.4504 7.70762 26.183 7.9086 25.9699L31.9086 0.469884C32.1405 0.223281 32.4491 0.0623896 32.784 0.0133695C33.119 -0.0356507 33.4607 0.0300834 33.7536 0.199884V0.202884Z",
    fill: "#A3AED0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1341_4089"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnergie);
export default __webpack_public_path__ + "static/media/Energie.63937884767ba6986ea877b7a044970a.svg";
export { ForwardRef as ReactComponent };